// extracted by mini-css-extract-plugin
export var capitalize = "CustomService-module--capitalize--10043";
export var formFields = "CustomService-module--formFields--9a348";
export var root = "CustomService-module--root--652fa";